export const EXPOSE_SUCCESS_SW = 'fin_credit_abroad_apply_bureau_signin_sw';
export const EXPOSE_FAIL_SW = 'fin_credit_abroad_apply_bureau_signin_fail_sw';
export const PAGE_CLICK_CK = 'fin_credit_abroad_apply_bureau_signin_ck';
export const REG_PHONE_INPUT_SW = 'fin_credit_abroad_sign_phone_typ';
export const PHONE_VERIFY_SW = 'fin_credit_abroad_sign_phone_passport_verif_bt';
export const REG_LOGIN_SUCCESS_SW =
    'fin_credit_abroad_application_card_register_bt';
export const REG_LOGIN_FAIL_SW =
    'fin_credit_abroad_application_card_register_fail_bt';
export const LOGIN_STATE_CK = 'fin_credit_abroad_login_state_ck';
export const LOGIN_STATUS_BT = 'fin_credit_abroad_2in1_login_status_bt';
export const AWARD_PAGE_EXPOSE_SW = 'fin_credit_abroad_award_sw';
export const POLICY_POPUP_SW = 'fin_credit_abroad_2in1_protocol_popup_sw';
export const POLICY_POPUP_CK = 'fin_credit_abroad_2in1_protocol_popup_ck';
export const RETAIN_POPUP_CK = 'fin_credit_abroad_2in1_retain_popup_ck';
export const LANDING_TIME_SW = 'fin_credit_abroad_apply_bureau_time_sw';

export const TechBtnId = {
    JUMP: 'tech_url_jump'
};
